import { Link } from 'react-router-dom';

const encyclopediaMap = [
  {
    category: 'Основы корпоративного обучения',
    icon: 'ri-book-open-line',
    items: [
      { label: 'Что такое корпоративное обучение', to: '/enciklopediya-korporativnogo-obucheniya/chto-takoe-korporativnoe-obuchenie' },
      { label: 'Обучение персонала', to: '/enciklopediya-korporativnogo-obucheniya/obuchenie-personala' },
      { label: 'Разработка программ обучения', to: '/enciklopediya-korporativnogo-obucheniya/razrabotka-programm-obucheniya' },
    ],
  },
  {
    category: 'Ключевые направления',
    icon: 'ri-compass-3-line',
    items: [
      { label: 'Обучение отдела продаж', to: '/enciklopediya-korporativnogo-obucheniya/obuchenie-otdela-prodazh' },
      { label: 'Тренинг для руководителей', to: '/enciklopediya-korporativnogo-obucheniya/trening-dlya-rukovoditeley' },
      { label: 'Развитие Soft Skills', to: '/enciklopediya-korporativnogo-obucheniya/razvitie-soft-skills' },
    ],
  },
  {
    category: 'Развитие команды',
    icon: 'ri-team-line',
    items: [
      { label: 'Командообразование', to: '/enciklopediya-korporativnogo-obucheniya/komandoobrazovanie' },
      { label: 'Адаптация сотрудников', to: '/enciklopediya-korporativnogo-obucheniya/adaptaciya-sotrudnikov' },
    ],
  },
  {
    category: 'Системы и оценка',
    icon: 'ri-dashboard-line',
    items: [
      { label: 'Корпоративная академия', to: '/enciklopediya-korporativnogo-obucheniya/korporativnaya-akademiya' },
      { label: 'Оценка эффективности обучения', to: '/enciklopediya-korporativnogo-obucheniya/ocenka-effektivnosti-obucheniya' },
    ],
  },
  {
    category: 'Продажи и переговоры',
    icon: 'ri-line-chart-line',
    items: [
      { label: 'Хаб «Продажи и переговоры»', to: '/prodazhi-i-peregovory' },
      { label: 'Тренинг по продажам', to: '/prodazhi-i-peregovory/trening-po-prodazham' },
      { label: 'Тренинг по переговорам', to: '/prodazhi-i-peregovory/trening-po-peregovoram' },
      { label: 'Холодные звонки', to: '/prodazhi-i-peregovory/trening-po-holodnym-zvonkam' },
      { label: 'Работа с возражениями', to: '/prodazhi-i-peregovory/trening-po-rabote-s-vozrazheniyami' },
    ],
  },
];

export default function EncyclopediaMapSection() {
  return (
    <section id="encyclopedia-map" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-gray-900 mb-6 leading-tight">
            Карта Энциклопедии
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Все материалы энциклопедии корпоративного обучения в одной удобной схеме. Выберите интересующий раздел и погрузитесь в тему.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {encyclopediaMap.map((section) => (
            <div
              key={section.category}
              className="bg-gray-50 rounded-2xl p-7 border border-gray-100 hover:shadow-lg transition-all duration-300"
            >
              {/* Category header */}
              <div className="flex items-center gap-3 mb-5 pb-4 border-b border-gray-200">
                <div className="w-10 h-10 bg-teal-100 rounded-lg flex items-center justify-center">
                  <i className={`${section.icon} text-xl text-teal-600`}></i>
                </div>
                <h3 className="text-lg font-bold text-gray-900">{section.category}</h3>
              </div>

              {/* Links */}
              <div className="flex flex-col gap-2">
                {section.items.map((item) => (
                  <Link
                    key={item.to}
                    to={item.to}
                    className="flex items-center gap-2 px-3 py-2.5 rounded-lg text-sm text-gray-700 hover:bg-white hover:text-teal-700 transition-all cursor-pointer group"
                  >
                    <i className="ri-arrow-right-s-line text-teal-400 group-hover:translate-x-1 transition-transform"></i>
                    <span>{item.label}</span>
                  </Link>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-12">
          <p className="text-gray-500 text-sm mb-4">
            Не нашли нужную тему? Свяжитесь с нами — мы поможем подобрать программу под ваши задачи.
          </p>
          <a
            href="#contact"
            className="inline-flex items-center gap-2 bg-teal-600 text-white px-7 py-3.5 rounded-lg text-sm font-semibold hover:bg-teal-700 transition-all transform hover:scale-105 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-chat-smile-3-line"></i>
            Получить консультацию
          </a>
        </div>
      </div>
    </section>
  );
}